import React, { Component } from 'react';
import { Row, Col, Button, Form, Modal } from 'react-bootstrap';
import { ServiceRequestsServices } from '../../pages/home/ServiceRequests/ServiceRequests.services'
import { formatDateTime } from '../../../_metronic/utils/utils';
import { Formik } from 'formik';
import * as Yup from 'yup'; // for everything
import { store } from 'react-notifications-component';
import * as firebase from 'firebase/app';

const addNotesSchema = Yup.object().shape({
  content: Yup.string().required('Please write something to save this note.')
})

class NotesComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props,
      notes: this.props.notes,
      allowAddNotes: this.props.allowAddNotes,
      showAddNoteModal: false,
    };
  }

  //   static getDerivedStateFromProps(props, state) {
  //     let result = {}
  //     if (!_.isEqual(props.rmProfile, state.rmProfile)) {
  //         result.rmProfile = props.rmProfile
  //     }
  //     return Object.keys(result).length > 0 ? result : null;
  // }

  handleAddNoteClick = async () => {
    this.setState(state => ({ showAddNoteModal: !state.showAddNoteModal }));
  }

  static getDerivedStateFromProps(props, state) {
    let result = {}
    if (state.notes.length !== props.notes.length) {
      result.notes = props.notes
    }
    return Object.keys(result).length > 0 ? result : null;
  }

  render() {
    return (
      <>
        {/* Section Header */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div style={{ fontSize: '12px', fontWeight: 700, color: '#555', textTransform: 'uppercase', letterSpacing: '0.6px' }}>Notes</div>
          <div>
            {this.state.allowAddNotes && !this.state.isReport && <Button variant="outline-primary" size="sm" onClick={this.handleAddNoteClick} style={{ fontSize: '12px' }}>+ Add Note</Button>}
            
            {this.state.allowAddNotes && this.state.isReport === "MOVEINREPORT" && this.state.isMoveInReportPublished !== true && <Button variant="outline-primary" size="sm" onClick={this.handleAddNoteClick} style={{ fontSize: '12px' }}>+ Add Note</Button>}
            {this.state.allowAddNotes && this.state.isReport === "MOVEOUTREPORT" && this.state.isMoveOutReportPublished !== true && <Button variant="outline-primary" size="sm" onClick={this.handleAddNoteClick} style={{ fontSize: '12px' }}>+ Add Note</Button>}
          </div>
        </div>

        {this.state.notes.length === 0 && (
          <div style={{ padding: '6px 0 10px', color: '#999', fontSize: '13px' }}>No Notes</div>
        )}

        {this.state.notes && this.state.notes.map(note => {
          const initials = note?.user?.fullName
            ? note.user.fullName.split(' ').map(w => w[0]).slice(0, 2).join('').toUpperCase()
            : '?';
          return (
            <div key={note.id} style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: '10px',
              padding: '10px 14px',
              marginBottom: '8px',
              border: '1px solid #e9ecef',
              borderRadius: '8px',
              backgroundColor: '#fafcff',
              boxShadow: '0 1px 3px rgba(0,0,0,0.04)'
            }}>
              {/* Avatar */}
              <div style={{
                flexShrink: 0,
                width: '34px', height: '34px',
                borderRadius: '50%',
                backgroundColor: '#4a90d9',
                color: '#fff',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: '12px', fontWeight: 700
              }}>
                {initials}
              </div>
              {/* Content */}
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '3px' }}>
                  <span style={{ fontWeight: 600, fontSize: '13px', color: '#1a1a2e' }}>
                    {note?.user?.fullName || 'Unknown'}
                  </span>
                  {note?.createdAt && (
                    <span style={{ fontSize: '11px', color: '#aaa' }}>{formatDateTime(note.createdAt)}</span>
                  )}
                </div>
                <p style={{ margin: 0, fontSize: '13px', color: '#555' }}>
                  {note?.content}
                </p>
                {!note.createdAt && (
                  <p style={{ margin: 0, fontSize: '12px', color: '#aaa' }}><em>Timestamp unavailable</em></p>
                )}
              </div>
            </div>
          );
        })}
        <Modal backdrop="static" keyboard={false} show={this.state.showAddNoteModal} onHide={this.handleAddNoteClick}>
          <Modal.Header closeButton>
            <Modal.Title>Add Note</Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <Formik
              initialValues={{
                serviceRequestId: this.state.serviceRequestId ? this.state.serviceRequestId : undefined,
                invoiceId: this.state.invoiceId ? this.state.invoiceId : undefined,
                // workId: this.state.workId ? (this.state.workId) : (this.state.renewalWorkId ? this.state.renewalWorkId : null),
                workId: this.state.workId || this.state.renewalWorkId || this.state.preMoveInWorksId || this.state.rentEscalationWorkId || undefined,
                leaseId: this.state.leaseId || undefined,
                tenantRentpaymentBillId: this.state.rentPaymentId || undefined,
                paymentBillId: this.state.paymentBillId || undefined,
                noticePeriodId: this.state.noticePeriodInitiatedLeaseId || undefined,
                groupName: ((this.state.leaseId || this.state.noticePeriodId) && 'LEASE_TERMINATION') || undefined,
                content: undefined,
              }}
              validationSchema={addNotesSchema}
              onSubmit={async (values) => {
                const serviceRequestNoteData = {
                  'note': {
                    ...values
                  }
                }
                const result = await ServiceRequestsServices.addNotes(serviceRequestNoteData)
                if (result.status === 201) {
                  store.addNotification({
                    title: "Success!",
                    message: `Note added!`,
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                      duration: 5000,
                      onScreen: true,
                      showIcon: true,
                      pauseOnHover: true
                    }
                  });
                  if (this.state.serviceRequestId) {
                    firebase.analytics().logEvent("add_note_button_click", { description: "Add Note Button Clicked", addNoteFrom: 'Service Requests' });
                    this.props.parentCallback(values.serviceRequestId);
                  } else if (this.state.workId) {
                    // For Inspections Work
                    firebase.analytics().logEvent("add_note_button_click", { description: "Add Note Button Clicked", addNoteFrom: 'Inspection' });
                    this.props.parentCallback(values.workId)
                  } else if (this.state.renewalWorkId) {
                    firebase.analytics().logEvent("add_note_button_click", { description: "Add Note Button Clicked", addNoteFrom: 'PMS Renewals' });
                    this.props.parentCallback(values.workId)
                  } else if (this.state.isDocumentation) {
                    firebase.analytics().logEvent("add_note_button_click", { description: "Add Note Button Clicked", addNoteFrom: 'Documentation in Lease Profile' });
                    this.props.parentCallback('DOCUMENTATION');
                  } else if (this.state.isFurnishing) {
                    firebase.analytics().logEvent("add_note_button_click", { description: "Add Note Button Clicked", addNoteFrom: 'Furnishing in Lease Profile' });
                    this.props.parentCallback('FURNISHING');
                  } else if (this.state.isReport === 'MOVEINREPORT') {
                    firebase.analytics().logEvent("add_note_button_click", { description: "Add Note Button Clicked", addNoteFrom: 'Move-in Work in Lease Profile' });
                    this.props.parentCallback('MOVEINREPORT')
                  } else if (this.state.isReport === 'MOVEOUTREPORT') {
                    firebase.analytics().logEvent("add_note_button_click", { description: "Add Note Button Clicked", addNoteFrom: 'Move-out Work in Lease Profile' });
                    this.props.parentCallback('MOVEOUTREPORT')
                  } else if (this.state.rentPaymentId) {
                    firebase.analytics().logEvent("add_note_button_click", { description: "Add Note Button Clicked", addNoteFrom: 'Rent Payment Bills' });
                    this.props.parentCallback(values.tenantRentpaymentBillId);
                  } else if (this.state.paymentBillId) {
                    firebase.analytics().logEvent("add_note_button_click", { description: "Add Note Button Clicked", addNoteFrom: 'Security Deposit Payment Bills' });
                    this.props.parentCallback(values.paymentBillId);
                  } else if (this.state.rentEscalationWorkId) {
                    firebase.analytics().logEvent("add_note_button_click", { description: "Add Note Button Clicked", addNoteFrom: 'Rent Escalations' });
                    this.props.parentCallback(values.workId);
                  } else if (this.state.leaseId) {
                    firebase.analytics().logEvent("add_note_button_click", { description: "Add Note Button Clicked", addNoteFrom: 'Expiring Leases in Lease Terminations' });
                    this.props.parentCallback(values.leaseId);
                  } else if (this.state.noticePeriodInitiatedLeaseId) {
                    firebase.analytics().logEvent("add_note_button_click", { description: "Add Note Button Clicked", addNoteFrom: 'Notice Period Initiated Leases in Lease Terminations' });
                    this.props.parentCallback(values.noticePeriodId);
                  } else {
                    firebase.analytics().logEvent("add_note_button_click", { description: "Add Note Button Clicked", addNoteFrom: 'Invoices' });
                    this.props.parentCallback(values.invoiceId);
                  }
                  this.setState(state => ({ showAddNoteModal: !state.showAddNoteModal }));
                }
              }}
            >
              {
                ({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, arrayHelpers }) => (
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col xs={12}>
                        <Form.Group controlId="content">
                          <Form.Control as="textarea" name="content" type="text" placeholder="Write here..." onChange={handleChange} onBlur={handleBlur} value={values.content} />
                          {errors.content && touched.content && <Form.Text className="text-danger">{errors.content}</Form.Text>}
                        </Form.Group>
                      </Col>
                      <Col xs={12} className="mt-2 text-right">
                        <Button variant="secondary" className="mr-2" onClick={this.handleAddNoteClick}>
                          Cancel
                        </Button>
                        <Button variant="primary" type="submit" disabled={isSubmitting}>
                          {isSubmitting ? 'Saving...' : 'Save'}
                        </Button>
                      </Col>
                    </Row>
                  </Form>)}
            </Formik>
          </Modal.Body>
        </Modal>
      </>
    )
  }
}

export default NotesComponent;
